export default {
    getUser(state) {
        return state.user;
    },
    getUserInfo(state) {
        return state.userInfo;
    },
};